import React from "react";
import { AppRoutes } from "../../domain/navigation/AppRoutes";
import { BaseComponent } from "../core/BaseComponent";
import "./EmployeeGroup.css";
import { EmployeeGroupListTable } from "./EmployeeGroupListTable";


export class EmployeeGroupList extends BaseComponent<{}, any> {
    render() {
        return (<div className="employee-group-list">
            <div className="toolbar">
                <div className="default-button" onClick={() => this.newGroup()}>Nieuwe groep</div>
            </div>

            <EmployeeGroupListTable />


        </div>);
    }
    newGroup(): void {
        this.navigateTo(`${AppRoutes.employeegroups}/new`);
    }
}
